module.exports = __webpack_public_path__ + "static/media/yuvaa-logo.904d801e.png";